import { useCallback, useRef } from 'react';

export const useDelayedSave = (func, delay = 3000) => {
  const funcRef = useRef(func);
  funcRef.current = func;
  const saveDelay = useRef();

  const cancel = useCallback(() => {
    if (saveDelay.current) {
      clearTimeout(saveDelay.current);
      saveDelay.current = undefined;
    }
  }, []);

  const save = useCallback(
    (...args) => {
      cancel();
      saveDelay.current = setTimeout(() => funcRef.current(...args), delay);
    },
    [cancel, delay]
  );

  return [save, cancel];
};
